import request from './../../../utilities/request';
import localStorageToken from './../../../utilities/storage';

function list(page, query) {
  return request({
    url:    `/shop/cupon/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
};

function find(id) {
  return request({
    url:    `/shop/cupon/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
};

function save(values) {
  return request({
    url:    '/shop/cupon/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
};

function update(id, values) {
  return request({
    url:    `/shop/cupon/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
};

function remove(id) {
  return request({
    url:    `/shop/cupon/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
};

function filter(params) {
  return request({
    url:    '/shop/cupon/filter',
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params: params
  });
};

const ShopCuponService = {
  list, find, save, update, remove, filter
};

export default ShopCuponService;
